import * as networkService from './networkService'

// The submit used to post an empty body, which let the server classify the submission
// against the phase row as it stood at that instant. If a broker promoted the candidate
// while the form was open, the app had asked only the visitor questions but the server
// treated the send as a candidacy and copied candidacy fields out of the shared central
// profile: values this candidate never offered to this broker.
//
// The submit now carries the step the form was actually built from, and the server
// classifies against that. Nothing is refused and the candidate is never interrupted: they
// answered what they were asked, and a broker changing their mind mid-form is not theirs to
// resolve on a screen. This one field is the whole mechanism.
//
// Keep this name in step with the legacy API and with the rentmatch fork.
export const SUBMITTED_STEP_FIELD = 'submittedStep'

export const sendApplicationToBroker = (userId, propertyId, submittedStep) =>
  networkService.fetchApi(
    `/users/${userId}/application/sendToBroker/${propertyId}`,
    { [SUBMITTED_STEP_FIELD]: submittedStep },
    'post',
  )

// Reads the error code without assuming the response is shaped as expected. The handlers in
// the views used to destructure err.response.data.error directly, which throws on a network
// failure that has no response, replacing the real error with a TypeError.
export const getErrorCode = err => {
  const response = err && err.response
  const data = response && response.data
  const error = data && data.error
  return error && error.code
}



// WEBPACK FOOTER //
// ./src/services/applicationSubmitService.js